// Maps our TokenSet -> antd v5 ThemeConfig so antd components inherit the
// active palette automatically.

import { theme as antdTheme, ThemeConfig } from 'antd';
import { TokenSet, ThemeMode } from './tokens';

export function antdThemeFromTokens(tokens: TokenSet, mode: ThemeMode): ThemeConfig {
  return {
    cssVar: true,
    hashed: false,
    algorithm: mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: tokens.color.accent,
      colorSuccess: tokens.color.success,
      colorWarning: tokens.color.warn,
      colorError: tokens.color.danger,
      colorInfo: tokens.color.accent,
      colorBgBase: tokens.color.bg,
      colorTextBase: tokens.color.text,
      colorBgContainer: tokens.color.panel,
      colorBgElevated: tokens.color.panel,
      colorBorder: tokens.color.border,
      colorBorderSecondary: tokens.color.border,
      borderRadius: tokens.radius.md,
      borderRadiusLG: tokens.radius.lg,
      borderRadiusSM: tokens.radius.sm,
      fontFamily: tokens.font.sans,
      fontSize: 14,
    },
    components: {
      Table: {
        headerBg: tokens.color.bg,
        headerColor: tokens.color.text3,
        rowHoverBg: tokens.color.bgElevated,
        borderColor: tokens.color.border,
      },
      Menu: {
        itemBg: 'transparent',
        itemSelectedBg: tokens.color.accentSoft,
        itemSelectedColor: tokens.color.accent,
        itemHoverBg: tokens.color.bgElevated,
      },
      Layout: {
        bodyBg: tokens.color.bg,
        headerBg: tokens.color.panel,
        siderBg: tokens.color.panel,
      },
    },
  };
}
